<mat-form-field class="w-100">
    <!--
        Important for devs: If you are trying to set the value of this initially from a parent component and you are using a displayWith function then
        you'll want the [filter] attribute equal to the model and not a simple string (even though the type is a string).
        Ask Mike for more details.
    -->
    <mat-label>{{ label }}</mat-label>
    <input
        [disabled]="disabled"
        type="text"
        [placeholder]="label"
        matInput
        (input)="onFilterChanged()"
        [(ngModel)]="filter"
        [matAutocomplete]="auto"
    />
    <mat-autocomplete
        #auto="matAutocomplete"
        autoActiveFirstOption
        (optionSelected)="optionSelected($event)"
        [displayWith]="displayFn"
        [panelWidth]="panelWidth"
    >
        <mat-option *ngFor="let option of filteredOptions" [value]="option">
            {{ renderOption(option) }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
